/**
 * Formats an ISO date string into a human-readable format.
 * @param {string} isoString - The ISO date string to format.
 * @returns {string} - The formatted date string.
 */
export const formatDateTime = (isoString) => {
    if (!isoString) return "";
    try {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString; // Return original if invalid

        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    } catch (e) {
        return isoString;
    }
};

/**
 * Formats an ISO date string into a relative time string (e.g., "2 hours ago").
 * @param {string} isoString - The ISO date string to format.
 * @returns {string} - The relative time string.
 */
export const formatRelativeTime = (isoString) => {
    if (!isoString) return "";
    try {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString;

        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 0) return formatDateTime(isoString); // Future date
        if (diffInSeconds < 60) return "just now";
        if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
        if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;

        if (diffInSeconds < 172800) return "yesterday";

        return formatDateTime(isoString);
    } catch (e) {
        return isoString;
    }
};
